import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const lastGood = new Map();
const keyOf = (c) => `${c.url}|${JSON.stringify(c.params || {})}`;
export const isBusy = (e) => !e.response || [502, 503, 504].includes(e.response.status);
export const setStale = (on) => window.dispatchEvent(new CustomEvent("api-stale", { detail: on }));
const setRetrying = (on) => {
  if (window.__apiRetrying === on) return;
  window.__apiRetrying = on;
  window.dispatchEvent(new CustomEvent("api-retrying", { detail: on }));
};

let refreshing = null;
api.interceptors.response.use(
  (r) => {
    if ((r.config.method || "get") === "get") {
      if (lastGood.size > 300) lastGood.delete(lastGood.keys().next().value);
      lastGood.set(keyOf(r.config), r);
      setStale(false);
      setRetrying(false);
    }
    return r;
  },
  async (err) => {
    const cfg = err.config || {};
    if ((cfg.method || "get") === "get" && isBusy(err) && !axios.isCancel(err)) {
      if (!cfg._busyRetry) {
        cfg._busyRetry = true;
        await new Promise((r) => setTimeout(r, 2000));
        try { return await api(cfg); } catch (e2) { err = e2; }
      }
      const cached = lastGood.get(keyOf(cfg));
      if (cached) { setStale(true); return { ...cached, stale: true }; }
      setRetrying(true);
    }
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try { await refreshing; return api(cfg); } catch (e) { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${x.loc ? x.loc[x.loc.length - 1] + ": " : ""}${x.msg}` : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const fmt = (n, d = 2) => (n == null || Number.isNaN(n) ? "—" : Number(n).toLocaleString("en-MY", { minimumFractionDigits: d, maximumFractionDigits: d }));
export const rm = (n) => (n == null ? "—" : `${n < 0 ? "-" : ""}RM${fmt(Math.abs(n))}`);
export const pnlClass = (n) => (n > 0 ? "text-emerald-600" : n < 0 ? "text-red-600" : "text-slate-700");
export const ts = (s) => (s ? new Date(s).toLocaleString("en-GB", { hour12: false }) : "—");
